// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddProrationBidContractRevisionMutationVariables = Types.Exact<{
  input: Types.SaveBidContractRevisionInput;
}>;


export type AddProrationBidContractRevisionMutation = { __typename?: 'Mutation', saveBidContractRevision: { __typename?: 'SaveBidContractRevisionResult', bidContractRevision: { __typename?: 'BidContractRevision', id: string } } };

export type AddProrationBidContractMutationVariables = Types.Exact<{
  input: Types.SaveBidContractInput;
}>;


export type AddProrationBidContractMutation = { __typename?: 'Mutation', saveBidContract: { __typename?: 'SaveBidContractResult', bidContract: { __typename?: 'BidContract', id: string, currentRevision: { __typename?: 'BidContractRevision', id: string } } } };

export type SaveProrationTradeLineItemsMutationVariables = Types.Exact<{
  input: Types.SaveBidContractTradeLineItemsInput;
}>;


export type SaveProrationTradeLineItemsMutation = { __typename?: 'Mutation', saveBidContractTradeLineItems: { __typename?: 'SaveBidContractTradeLineItemsResult', bidContractTradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string }> } };

export type EditProratedBidRevisionQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
}>;


export type EditProratedBidRevisionQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, type?: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, tradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string } | { __typename?: 'ItemTemplateItem', id: string } | { __typename?: 'TakeoffLineItem', id: string } | { __typename?: 'TakeoffLineItemVersion', id: string } | null | undefined }> }> } };

export type EditBidContractTradeLineItemFragment = { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string } | { __typename?: 'ItemTemplateItem', id: string } | { __typename?: 'TakeoffLineItem', id: string } | { __typename?: 'TakeoffLineItemVersion', id: string } | null | undefined }> };

export const EditBidContractTradeLineItemFragmentDoc = gql`
    fragment EditBidContractTradeLineItem on BidContractTradeLineItem {
  id
  totalCostInCents
  productOffering {
    id
  }
  options {
    id
  }
  lineItems {
    id
    totalCostInCents
    itemTemplateItem {
      id
    }
  }
}
    `;
export const AddProrationBidContractRevisionDocument = gql`
    mutation AddProrationBidContractRevision($input: SaveBidContractRevisionInput!) {
  saveBidContractRevision(input: $input) {
    bidContractRevision {
      id
    }
  }
}
    `;
export type AddProrationBidContractRevisionMutationFn = Apollo.MutationFunction<AddProrationBidContractRevisionMutation, AddProrationBidContractRevisionMutationVariables>;

/**
 * __useAddProrationBidContractRevisionMutation__
 *
 * To run a mutation, you first call `useAddProrationBidContractRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProrationBidContractRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProrationBidContractRevisionMutation, { data, loading, error }] = useAddProrationBidContractRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProrationBidContractRevisionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProrationBidContractRevisionMutation, AddProrationBidContractRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProrationBidContractRevisionMutation, AddProrationBidContractRevisionMutationVariables>(AddProrationBidContractRevisionDocument, options);
      }
export type AddProrationBidContractRevisionMutationHookResult = ReturnType<typeof useAddProrationBidContractRevisionMutation>;
export type AddProrationBidContractRevisionMutationResult = Apollo.MutationResult<AddProrationBidContractRevisionMutation>;
export type AddProrationBidContractRevisionMutationOptions = Apollo.BaseMutationOptions<AddProrationBidContractRevisionMutation, AddProrationBidContractRevisionMutationVariables>;
export const AddProrationBidContractDocument = gql`
    mutation AddProrationBidContract($input: SaveBidContractInput!) {
  saveBidContract(input: $input) {
    bidContract {
      id
      currentRevision {
        id
      }
    }
  }
}
    `;
export type AddProrationBidContractMutationFn = Apollo.MutationFunction<AddProrationBidContractMutation, AddProrationBidContractMutationVariables>;

/**
 * __useAddProrationBidContractMutation__
 *
 * To run a mutation, you first call `useAddProrationBidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProrationBidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProrationBidContractMutation, { data, loading, error }] = useAddProrationBidContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProrationBidContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProrationBidContractMutation, AddProrationBidContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProrationBidContractMutation, AddProrationBidContractMutationVariables>(AddProrationBidContractDocument, options);
      }
export type AddProrationBidContractMutationHookResult = ReturnType<typeof useAddProrationBidContractMutation>;
export type AddProrationBidContractMutationResult = Apollo.MutationResult<AddProrationBidContractMutation>;
export type AddProrationBidContractMutationOptions = Apollo.BaseMutationOptions<AddProrationBidContractMutation, AddProrationBidContractMutationVariables>;
export const SaveProrationTradeLineItemsDocument = gql`
    mutation SaveProrationTradeLineItems($input: SaveBidContractTradeLineItemsInput!) {
  saveBidContractTradeLineItems(input: $input) {
    bidContractTradeLineItems {
      id
    }
  }
}
    `;
export type SaveProrationTradeLineItemsMutationFn = Apollo.MutationFunction<SaveProrationTradeLineItemsMutation, SaveProrationTradeLineItemsMutationVariables>;

/**
 * __useSaveProrationTradeLineItemsMutation__
 *
 * To run a mutation, you first call `useSaveProrationTradeLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProrationTradeLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProrationTradeLineItemsMutation, { data, loading, error }] = useSaveProrationTradeLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProrationTradeLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProrationTradeLineItemsMutation, SaveProrationTradeLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProrationTradeLineItemsMutation, SaveProrationTradeLineItemsMutationVariables>(SaveProrationTradeLineItemsDocument, options);
      }
export type SaveProrationTradeLineItemsMutationHookResult = ReturnType<typeof useSaveProrationTradeLineItemsMutation>;
export type SaveProrationTradeLineItemsMutationResult = Apollo.MutationResult<SaveProrationTradeLineItemsMutation>;
export type SaveProrationTradeLineItemsMutationOptions = Apollo.BaseMutationOptions<SaveProrationTradeLineItemsMutation, SaveProrationTradeLineItemsMutationVariables>;
export const EditProratedBidRevisionDocument = gql`
    query EditProratedBidRevision($bidContractRevisionId: ID!) {
  bidContractRevision(id: $bidContractRevisionId) {
    id
    bidContract {
      id
      type {
        code
      }
      tradePartner {
        id
        name
      }
    }
    tradeLineItems {
      ...EditBidContractTradeLineItem
    }
  }
}
    ${EditBidContractTradeLineItemFragmentDoc}`;

/**
 * __useEditProratedBidRevisionQuery__
 *
 * To run a query within a React component, call `useEditProratedBidRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProratedBidRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProratedBidRevisionQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *   },
 * });
 */
export function useEditProratedBidRevisionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables> & ({ variables: EditProratedBidRevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>(EditProratedBidRevisionDocument, options);
      }
export function useEditProratedBidRevisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>(EditProratedBidRevisionDocument, options);
        }
// @ts-ignore
export function useEditProratedBidRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>;
export function useEditProratedBidRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditProratedBidRevisionQuery | undefined, EditProratedBidRevisionQueryVariables>;
export function useEditProratedBidRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>(EditProratedBidRevisionDocument, options);
        }
export type EditProratedBidRevisionQueryHookResult = ReturnType<typeof useEditProratedBidRevisionQuery>;
export type EditProratedBidRevisionLazyQueryHookResult = ReturnType<typeof useEditProratedBidRevisionLazyQuery>;
export type EditProratedBidRevisionSuspenseQueryHookResult = ReturnType<typeof useEditProratedBidRevisionSuspenseQuery>;
export type EditProratedBidRevisionQueryResult = Apollo.QueryResult<EditProratedBidRevisionQuery, EditProratedBidRevisionQueryVariables>;